module.exports = __webpack_public_path__ + "static/media/street-view.18f53cbf.svg";